import { FilterType } from '@appTypes/urlParamsType';

// Filter keys whose URL value is a boolean-ish string ('true') rather than a
// human-readable label. Mapped to the visible Norwegian label.
const BOOLEAN_FILTER_LABELS: Partial<Record<keyof FilterType, string>> = {
  trailerHitch: 'Tilhengerfeste',
  tested: 'Testet',
};

const capitalizeFirst = (s: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export const getChipLabel = (filterKey: keyof FilterType, value: string) =>
  BOOLEAN_FILTER_LABELS[filterKey] ?? capitalizeFirst(value);
